import { inject, Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { BasicError } from 'projects/shared/lib/error/basic-error';
import { ContentGetQuery, ContentGetQueryResult, EContentLocation, EError } from '../../INTEGRA_Shop_Client';
import { IContentApiService, IContentApiServiceToken } from '../../api/content/content-api-service.interface';
import { IContentService, IContentServiceToken } from './content-service.interface';
import { ErrorCodeService } from '../../infrastructure/error-code.service';

@Injectable({
  providedIn: 'root'
})
export class ContentService implements IContentService {
  private readonly contentApiService: IContentApiService;

  public constructor() {
    this.contentApiService = inject(IContentApiServiceToken);
  }

  public contentGet(parent?: string, location?: EContentLocation): Observable<ContentGetQueryResult> {
    let contentGetQuery: ContentGetQuery = new ContentGetQuery();
    if (parent == null || location == null) {
      throw new BasicError("missing parameters in contentGet", ErrorCodeService.formatErrorCode(EError.F330040));
    }
    contentGetQuery.parent = parent;
    contentGetQuery.location = location;

    return this.contentApiService.swagContentGet(contentGetQuery);
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ContentServiceProvider: Provider[] = [
  { provide: IContentServiceToken, useExisting: ContentService }
];
